import { Button } from '@ibsys/kit';
import { CheckSquareIcon, ListFilterIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSampleSection } from '../../model/sampleSectionContext';

/**
 * Выбор записей выборки в строке управления списком — на месте переключателя «Действия» раздела
 * диалогов: включение флажков у строк и показ набранного. Показ набранного сужает список до
 * отмеченных диалогов, показывает их число и позволяет снять лишние прямо там; выход возвращает
 * прежний список с сохранёнными отметками.
 */
export const SamplePickingActions: FC = () => {
  const { t } = useTranslation(['samples']);
  const { canAdmin, isPicking, onTogglePicking, isPickedOnly, onTogglePickedOnly, pickedIds } = useSampleSection();

  if (!canAdmin) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Button
        variant={isPicking ? 'secondary' : 'ghost'}
        size="sm"
        aria-pressed={isPicking}
        onClick={onTogglePicking}
        icon={<CheckSquareIcon className="size-4" />}
      >
        {t('samples:picking.toggle')}
      </Button>
      {isPicking && pickedIds.length > 0 && (
        <Button
          variant={isPickedOnly ? 'secondary' : 'ghost'}
          size="sm"
          aria-pressed={isPickedOnly}
          onClick={onTogglePickedOnly}
          icon={<ListFilterIcon className="size-4" />}
        >
          {t('samples:picking.showPicked', { count: pickedIds.length })}
        </Button>
      )}
    </div>
  );
};
